import { makeStyles, Theme } from '@material-ui/core/styles';
import COLORS from 'config/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: '20px 35px 15px',
    minWidth: '100%',

    '& .MuiGrid-item': {

      '& .MuiButton-root': {
        height: 35,
        width: 175,
      },

      '& .MuiButton-text': {
        padding: '8px 25px',
      },
    },

    [theme.breakpoints.down('xs')]: {
      padding: 20,

      '& .MuiGrid-item': {
        width: '100%',
        height: 'auto',
      },
    },
  },
  link: {
    color: COLORS.blueNormal,
    textDecoration: 'underline',

    '&:hover': {
      color: COLORS.blueDark,
      cursor: 'pointer',
    },
  },
  contactCourier: {
    marginTop: 12,
    boxShadow: '0px 2px 4px rgba(40, 78, 102, 0.2) !important',

    [theme.breakpoints.down('xs')]: {
      width: '95% !important',
    },
  },
  courierLogo: {
    height: 44,
    borderRadius: 4,
    marginRight: 8,
  },
  courierName: {
    display: 'flex',
    alignItems: 'center',

    '& p': {
      wordBreak: 'normal',
      width: 168,

      [theme.breakpoints.down('xs')]: {
        width: '100%',
        maxWidth: 210,
      },
    },
  },
  verticalAlign: {
    display: 'flex',
    alignItems: 'center',
  }
}));
